(() => {
  if (window.spectreReady) return;
  window.spectreReady = true;
  const drawer = document.getElementById('spectre-cart-drawer');
  if (!drawer) return;
  const strings = JSON.parse(document.getElementById('spectre-cart-strings').textContent);
  const content = drawer.querySelector('[data-drawer-content]');
  const footer = drawer.querySelector('[data-drawer-footer]');
  const errorBox = drawer.querySelector('[data-drawer-error]');
  const checkout = drawer.querySelector('[data-drawer-checkout]');
  let cart = null, busy = false, timer, returnFocus, oldOverflow, changed = false, valid = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-MY', {style:'currency',currency:cart?.currency || 'MYR'}).format(Number(value) / 100);
  const selected = form => { const input = form.querySelector('[name=id]'); return {id:String(input.value),info:input.selectedOptions ? input.selectedOptions[0] : input}; };
  const quantity = id => cart ? cart.items.filter(item => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0) : 0;
  const request = async (path, body) => {
    const response = await fetch(root() + path, {cache:'no-store',headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},...(body ? {method:'POST',body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || strings.error);
    return data;
  };
  const readCart = async () => { cart = await request('cart.js'); valid = true; return cart; };
  const controls = () => {
    content.setAttribute('aria-busy', String(busy));
    drawer.querySelectorAll('[data-line-key] button,[data-line-key] input').forEach(node => node.disabled = busy);
    checkout.disabled = busy || !valid || !cart?.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(node => { if (cart) node.textContent = cart.item_count; });
    document.querySelectorAll('[data-quick-add]').forEach(form => {
      const {id,info} = selected(form), qty = quantity(id), add = form.querySelector('button[type=submit]');
      let stepper = form.querySelector('[data-stepper]');
      if (!stepper && form.closest('.card')) {
        stepper = document.createElement('div');
        stepper.className = 'quantity-stepper'; stepper.dataset.stepper = ''; stepper.hidden = true;
        stepper.innerHTML = `<button type="button" data-quantity-delta="-1" aria-label="${escape(strings.decrease)}">−</button><span class="quantity-middle" aria-live="polite"><strong data-in-cart>0</strong><small>${escape(strings.inCart)}</small></span><button type="button" data-quantity-delta="1" aria-label="${escape(strings.increase)}">+</button>`;
        form.append(stepper);
      }
      const limit = info.dataset.limit === '' || info.dataset.limit === undefined ? Infinity : Number(info.dataset.limit), available = info.dataset.available !== 'false';
      const picker = form.querySelector('select');
      if (picker) picker.disabled = busy;
      if (stepper) {
        add.hidden = qty > 0; stepper.hidden = qty === 0; stepper.setAttribute('aria-busy', String(busy));
        stepper.querySelector('[data-in-cart]').textContent = qty;
        stepper.querySelector('[data-quantity-delta="-1"]').disabled = busy || qty === 0;
        stepper.querySelector('[data-quantity-delta="1"]').disabled = busy || !available || qty >= limit;
      }
      add.disabled = busy || !available;
    });
  };
  const renderDrawer = () => {
    if (!cart) return;
    const active = drawer.contains(document.activeElement) ? document.activeElement : null;
    const focusKey = active?.closest('[data-line-key]')?.dataset.lineKey;
    const focusAction = active?.dataset.drawerAction;
    drawer.querySelector('[data-drawer-count]').textContent = cart.item_count;
    footer.hidden = cart.items.length === 0;
    drawer.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
    if (!cart.items.length) {
      content.innerHTML = `<div class="scd-empty"><p>${escape(strings.empty)}</p><button type="button" data-drawer-close>${escape(strings.continue)}</button></div>`;
    } else {
      content.innerHTML = cart.items.map(item => {
        const title = item.product_title || item.title;
        const image = item.featured_image?.url || item.image;
        const meta = [item.product_has_only_default_variant ? '' : item.variant_title, item.sku].filter(Boolean).join(' · ');
        const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value).map(([key,value]) => `<div class="scd-meta">${escape(key)}: ${escape(value)}</div>`).join('');
        return `<article class="scd-item" data-line-key="${escape(item.key)}"><a href="${escape(item.url)}" tabindex="-1" aria-hidden="true">${image ? `<img class="scd-image" src="${escape(image)}" alt="" width="80" height="112">` : ''}</a><div><div class="scd-item-head"><a class="scd-item-title" href="${escape(item.url)}">${escape(title)}</a><strong class="scd-line-total">${escape(money(item.final_line_price))}</strong></div><div class="scd-meta">${escape(meta)}</div>${properties}<div class="scd-price">${escape(money(item.final_price))} ${escape(strings.unit)}</div><div class="scd-actions"><div class="scd-quantity"><button type="button" data-drawer-action="decrease" aria-label="${escape(strings.decrease + ' ' + title)}">−</button><input type="number" inputmode="numeric" min="0" step="1" value="${item.quantity}" data-drawer-action="quantity" aria-label="${escape(strings.quantity + ' ' + title)}"><button type="button" data-drawer-action="increase" aria-label="${escape(strings.increase + ' ' + title)}">+</button></div><button class="scd-remove" type="button" data-drawer-action="remove" aria-label="${escape(strings.remove + ' ' + title)}">${escape(strings.remove)}</button></div></div></article>`;
      }).join('');
    }
    if (focusKey && drawer.open) {
      const row = [...content.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
      const focus = row?.querySelector(`[data-drawer-action="${focusAction}"]`) || drawer.querySelector('[data-drawer-close]');
      focus?.focus({preventScroll:true});
    }
  };
  const notify = (form, message) => {
    const toast = document.querySelector('.toast');
    toast.textContent = message;
    if (form?.dataset.view) {const link = document.createElement('a');link.href = root() + 'cart';link.textContent = form.dataset.view;toast.append(link);}
    toast.hidden = false; clearTimeout(timer); timer = setTimeout(() => toast.hidden = true, 5000);
  };
  const run = async (operation, form) => {
    if (busy) return;
    busy = true; errorBox.hidden = true; controls();
    try {
      await operation(); valid = true; renderDrawer();
    } catch (failure) {
      try {await readCart();renderDrawer();} catch {valid = false;}
      errorBox.textContent = failure.message || strings.error; errorBox.hidden = false;
      if (!drawer.open) notify(form, failure.message || strings.error);
    } finally {busy = false;controls();}
  };
  const refresh = () => run(readCart);
  const open = trigger => {
    if (!drawer.showModal) {window.location.assign(root() + 'cart');return;}
    if (!drawer.open) {
      returnFocus = trigger; oldOverflow = document.body.style.overflow;
      drawer.showModal(); document.body.style.overflow = 'hidden';
      document.querySelectorAll('.cart-link').forEach(node => node.setAttribute('aria-expanded', 'true'));
      drawer.querySelector('[data-drawer-close]').focus();
    }
    if (cart) renderDrawer();
    refresh();
  };
  const changeQuick = (form, delta) => run(async () => {
    const {id} = selected(form);
    await readCart();
    if (delta > 0) {await request('cart/add.js', {items:[{id,quantity:1}]});await readCart();}
    else {const line = cart.items.filter(item => String(item.variant_id) === id && item.quantity > 0).pop();if (!line) return;cart = await request('cart/change.js', {id:line.key,quantity:line.quantity - 1});}
    changed = true;
    if (!form.querySelector('[data-stepper]')) notify(form, form.dataset.added);
  }, form);
  const changeLine = (key, value) => run(async () => {
    if (!Number.isSafeInteger(value) || value < 0) throw new Error(strings.error);
    cart = await request('cart/change.js', {id:key,quantity:value});changed = true;
    drawer.querySelector('[data-drawer-status]').textContent = strings.updated;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && !link.hasAttribute('download') && (!link.target || link.target === '_self')) {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === (root() + 'cart').replace(/\/$/, '') && !url.search) {event.preventDefault();event.stopImmediatePropagation();open(link);return;}
    }
    if (event.target.closest('[data-drawer-close]')) {drawer.close();return;}
    const action = event.target.closest('button[data-drawer-action]');
    if (action) {
      const row = action.closest('[data-line-key]'), item = cart?.items.find(item => item.key === row.dataset.lineKey);
      if (item && !action.disabled) changeLine(item.key, action.dataset.drawerAction === 'remove' ? 0 : item.quantity + (action.dataset.drawerAction === 'increase' ? 1 : -1));
      return;
    }
    const button = event.target.closest('[data-quantity-delta]');
    if (button) {event.preventDefault();if (!button.disabled) changeQuick(button.closest('form'), Number(button.dataset.quantityDelta));}
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-quick-add]');
    if (form) {event.preventDefault();changeQuick(form, 1);}
    if (drawer.contains(event.target) && (busy || !valid || !cart?.item_count)) event.preventDefault();
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-drawer-action="quantity"]')) {const input = event.target;changeLine(input.closest('[data-line-key]').dataset.lineKey, input.value === '' ? NaN : Number(input.value));return;}
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0], card = event.target.closest('[data-product]');
    card.querySelector('[data-price]').textContent = option.dataset.price;
    card.querySelector('.stock').textContent = option.dataset.stock;
    if (card.querySelector('.card-meta')) card.querySelector('.card-meta').textContent = option.dataset.sku || '';
    card.dataset.price = option.dataset.cents || card.dataset.price;
    card.querySelector('button[type=submit]').textContent = option.dataset.available === 'true' ? card.dataset.add : card.dataset.sold;
    controls();
  });
  drawer.addEventListener('click', event => {if (event.target === drawer) drawer.close();});
  drawer.addEventListener('close', () => {
    document.body.style.overflow = oldOverflow || '';
    document.querySelectorAll('.cart-link').forEach(node => node.setAttribute('aria-expanded', 'false'));
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
    if (changed && location.pathname.replace(/\/$/, '') === (root() + 'cart').replace(/\/$/, '')) location.reload();
  });
  new MutationObserver(records => {if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.card') || node.querySelector('.card'))))) controls();}).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
